import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";

export const Constants = {
    NoInvestmentDataErrorMessage: "No documents were found matching the selection criteria",
    Error_FileFailToLoad: "Failed to load document.",
};

//Related to StandardLife.Platform.Distribution.Service.Api.Documents.Contract.DocumentCategory
export const DocumentTypeOptions: Dictionary[] = [
    { key: "9", value: "Consolidated Tax Certificate" },
    { key: "25", value: "Revised Client Tax Certificate" },
    { key: "5", value: "Document" },
    { key: "7", value: "SIPP/Bond document" },
    { key: "3", value: "Reports" },
    { key: "8", value: "Quotes" },
    { key: "17", value: "Product Key Information Document" },
    { key: "10", value: "Confirmations" },
    { key: "1", value: "Orders and trades" },
    { key: "6", value: "Forms" },
    { key: "13", value: "Other" },
    { key: "2", value: "Fund Fact Sheet" },
    { key: "12", value: "Consolidated Fund Fact Sheet" },
    { key: "11", value: "Consolidated KIID/Simplified Prospectus" },
    { key: "4", value: "Key Investor Information Document" },
    { key: "19", value: "Investment Key Information Document" },
    { key: "14", value: "Simplified Prospectus Document" },
    { key: "23", value: "Consolidated Investment Key Information Document" },
    { key: "16", value: "Supplementary Information Document" },
    { key: "22", value: "Consolidated Supplementary Information Document" },
];

export const DocumentTypeOptionGroups: Dictionary[] = [
    {
        key: "Tax certificates",
        value: [
            { key: "9", value: "Consolidated Tax Certificate" },
            { key: "25", value: "Revised Client Tax Certificate" },
        ],
    },
    {
        key: "Documents",
        value: [
            { key: "5", value: "Document" },
            { key: "7", value: "SIPP/Bond document" },
        ],
    },
    {
        key: "Reports",
        value: [{ key: "3", value: "Reports" }],
    },
    {
        key: "Quotes",
        value: [{ key: "8", value: "Quotes" }],
    },
    {
        key: "Other",
        value: [{ key: "13", value: "Other" }],
    },
    {
        key: "Product key information",
        value: [
            { key: "17", value: "Product Key Information Document" },
            { key: "10", value: "Confirmations" },
        ],
    },
    {
        key: "Trading notifications",
        value: [{ key: "1", value: "Orders and trades" }],
    },
    {
        key: "Forms",
        value: [{ key: "6", value: "Forms" }],
    },
    {
        key: "Investment key information",
        value: [
            { key: "2", value: "Fund Fact Sheet" },
            { key: "12", value: "Consolidated Fund Fact Sheet" },
            { key: "11", value: "Consolidated KIID/Simplified Prospectus" },
            { key: "4", value: "Key Investor Information Document" },
            { key: "19", value: "Investment Key Information Document" },
            { key: "14", value: "Simplified Prospectus Document" },
            { key: "23", value: "Consolidated Investment Key Information Document" },
            { key: "16", value: "Supplementary Information Document" },
            { key: "22", value: "Consolidated Supplementary Information Document" },
        ],
    },
];

export const enum DocStatusEnum {
    Created = "Created",
    SentClient = "SentClient",
    Received = "Received",
    SentWCC = "SentWCC",
    Archived = "Archived",
    Deleted = "Deleted",
}

export const DocumentStatusTypeToMap: Dictionary[] = [
    { key: DocStatusEnum.Created, value: "Created" },
    { key: DocStatusEnum.SentClient, value: "Sent to Client" },
    { key: DocStatusEnum.Received, value: "Received from Client" },
    { key: DocStatusEnum.SentWCC, value: "Sent to WCC" },
    { key: DocStatusEnum.Archived, value: "Archived" },
    { key: DocStatusEnum.Deleted, value: "Deleted" },
];
